/**
 * Tutorial guidato dei Permessi per ruolo.
 *
 * Nessun preparativo: la pagina e' un elenco di caselle, e il tutorial non ne tocca
 * nessuna - una spunta cambiata qui toglie o da' accesso a intere sezioni del
 * gestionale a tutti quelli che hanno quel ruolo.
 */
const SCOPE = '[data-tour-scope="setting-permissions"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createPermissionsTourSteps() {
	return [
		{
			body: "Qui si decide cosa vede ogni ruolo: amministratore, operatore, dipendente. Un ruolo e' un mestiere, non una persona - i permessi dati qui valgono per chiunque abbia quel ruolo, adesso e in futuro.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I permessi per ruolo',
		},
		{
			body: "La pagina e' divisa per ruolo: sotto ogni nome ci sono le caselle dei moduli del gestionale - ordini, prodotti, clienti, impostazioni. Spuntata vuol dire che quel ruolo vede quella voce nel menu e puo' usarla; tolta, la voce sparisce per tutti quelli che hanno quel ruolo.",
			key: 'roles',
			placement: 'top',
			target: at('roles'),
			title: 'I moduli di ogni ruolo',
		},
		{
			body: "Le spunte non si applicano subito: restano qui finche' non premi Salva configurazione. E' un bene, perche' permette di rileggere prima di confermare - ma vuol dire anche che uscendo dalla pagina senza salvare non hai cambiato niente.",
			key: 'save',
			placement: 'left',
			target: at('save'),
			title: 'Salvare la configurazione',
		},
	];
}
